import { StressSVG } from "./SVGIllustrations";
import { PillSelect } from "@/components/we360/PillSelect";
import { CalculatedBadge } from "@/components/we360/CalculatedBadge";
import { STRESS_ITEMS, STRESS_OPTIONS, classifyStress } from "./helpers";

export default function Step2Stress({ answers, onChange, allAnswered, score, errors }) {
  const cls = allAnswered ? classifyStress(score) : null;

  return (
    <div>
      <StressSVG />

      <div
        className="rounded-[14px] p-3 mt-3 mb-4 text-xs leading-relaxed"
        style={{ background: "#F3E5F0", border: "1px solid rgba(136,52,118,0.15)", color: "#2D2A24" }}
      >
        Marca la frecuencia con la que has vivido estas situaciones <strong>últimamente</strong>.
      </div>

      {STRESS_ITEMS.map((item, i) => (
        <div key={item.id} className="mb-4">
          <span className="text-xs font-semibold block mb-1" style={{ color: "#2D2A24" }}>
            {item.label}
          </span>
          <PillSelect
            options={STRESS_OPTIONS}
            value={answers[i] ?? ""}
            onChange={(v) => onChange(i, v)}
            error={errors?.getError(`str_${i}`)}
            testId={`f5-str-${item.id}`}
            columns={1}
          />
        </div>
      ))}

      {allAnswered && cls && (
        <CalculatedBadge
          label="Estrés / Burnout"
          value={`${score}/20`}
          category={cls.label}
          categoryColor={cls.color}
          testId="badge-estres"
        />
      )}
    </div>
  );
}
